<template lang="html">

  <b-modal ref="resetpasswordnotice" @ok="sendPasswordResetCode" @cancel="cancelNotice" no-close-on-esc no-close-on-backdrop hide-header-close title="Password Reset Required">

      <div class="d-block text-center">
       <p>Users are required to change the password on first login.</p>
       <p>You will recieve an email with an verification code that will allow you to create a new password. </p>

      <form @submit.stop.prevent="handleSubmit">
      </form>

       <div class="loader"> <stretch v-if="sendingCode" ></stretch> </div>
        <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">
               {{errorMsg}}
          </b-alert>

      </div>

      <!-- <slot name="modal-footer">
        <button type="submit" class="btn btn-lg btn-blade btn-block">Ok</button>
    </slot> -->

     <div slot="modal-footer" class="w-100">

         <b-btn size="lg" class="btn btn-lg btn-blade btn-block"  @click="sendPasswordResetCode">
           OK
         </b-btn>

          <!-- <b-btn size="lg" class="btn btn-lg btn-blade btn-block" @click="cancelNotice">
           Cancel
         </b-btn> -->
       </div>

    </b-modal>

</template>

<script lang="js">

import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'reset-password-notice',
  components: { Stretch },
  props: [],
  mounted () {
    var self = this
    self.$eventBus.$on('show-reset-notice', () => {
      self.$refs.resetpasswordnotice.show()
    })
  },
  data () {
    return {
      sendingCode: false,
      hasError: false,
      errorMsg: ''
    }
  },
  methods: {

    saySomething () {
      alert('yeah')
    },

    async sendPasswordResetCode (evt) {
      // evt.preventDefault()

      var self = this
      self.busy = true

      try {
        self.$auth.requestAccessToken().then(response => {
          self.$refs.resetpasswordnotice.hide()
          self.$eventBus.$emit('reset-code-sent')
        }).catch(() => {
          self.errorMsg = 'an error occurred. please retry or contact the administrator if the error continues'
          self.hasError = true
        })
      } catch (error) {
        self.errorMsg = 'an error occurred. please retry or contact the administrator if the error continues'
        self.hasError = true
      }
    },
    async cancelNotice () {
      var self = this
      await self.$auth.logOut()
      self.$refs.resetpasswordnotice.hide()
      self.$eventBus.$emit('reset-code-canceled')
    }
  },
  computed: {

  }
}
</script>
<style src="../assets/styles.css">

</style>



// WEBPACK FOOTER //
// src/components/ResetPasswordNotice.vue